import { useState, useEffect } from "react";
import { isSmallScreen } from "@/modules/app/appSlice";
import { Stack } from "@altimateai/lego";
import { Tooltip, Button } from "@altimateai/lego";
import { IconInfoCircle } from "@tabler/icons-react";

interface TimeInfoDisclaimerProps {
  color?: string;
  textToDisplay: React.ReactNode;
  numOfSecondsActive: number;
}

const TimeInfoDisclaimer = ({ textToDisplay, numOfSecondsActive }: TimeInfoDisclaimerProps) => {
  const [showInfo, setShowInfo] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowInfo(false);
    }, numOfSecondsActive * 1000); // milliseconds
    return () => {
      clearTimeout(timer);
    };
  }, [numOfSecondsActive]);

  if (!isSmallScreen) {
    return (
      <Button
        variant="ghost"
        className="al-bg-[rgba(17,30,49,0.04)] al-rounded-[10px] al-max-w-[30em]"
        onClick={() => setShowInfo(prevSetinfo => !prevSetinfo)}
      >
        <Stack direction="row" gap="xs" className="al-items-center">
          <IconInfoCircle size={16} />
          <span className="al-truncate">{showInfo && textToDisplay}</span>
        </Stack>
      </Button>
    );
  }

  return (
    <Tooltip title={textToDisplay}>
      <Button variant="ghost" className="al-bg-[rgba(17,30,49,0.04)] al-h-full al-max-w-[30em]">
        <IconInfoCircle size={16} />
      </Button>
    </Tooltip>
  );
};

export default TimeInfoDisclaimer;
